"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsServiceFactory = void 0;
const analytics_service_1 = require("./analytics-service");
class AnalyticsServiceFactory {
    static create(analyticsOptions) {
        return new analytics_service_1.AnalyticsService(analyticsOptions);
    }
    static initialize(analyticsOptionsOrService) {
        if (window.analyticsService) {
            return;
        }
        if (analyticsOptionsOrService instanceof analytics_service_1.AnalyticsService) {
            window.analyticsService = analyticsOptionsOrService;
            return;
        }
        window.analyticsService = AnalyticsServiceFactory.create(analyticsOptionsOrService);
    }
}
exports.AnalyticsServiceFactory = AnalyticsServiceFactory;
